<script setup>
import { computed, ref } from "vue";
import { useTimeoutPoll } from "@vueuse/core";
import Alert from "@/components/ui/Alert.vue";

const props = defineProps({
  url: {
    type: String,
    required: true
  }
});

const jobBatch = ref({});
const error = ref("");

const fetchBatch = async () => {
  try {
    const response = await fetch(props.url);
    const { data } = await response.json();
    jobBatch.value = data;
    if (jobBatch.value.pendingJobs === 0) {
      pause();
      setTimeout(() => {
        location.reload();
      }, 2000);
    }
  } catch (err) {
    error.value = err.message || "An error occurred.";
    pause();
  }
};

const isProcessing = computed(() => jobBatch.value.pendingJobs > 0)

const { pause } = useTimeoutPoll(fetchBatch, 750, {
  immediate: true
});
</script>

<template>
  <div>
    <Alert :variant="isProcessing ? 'warning': 'success'" class="tw:flex-1">
      <template v-if="isProcessing">
        {{ $t("Processing…") }} {{ jobBatch.totalJobs - jobBatch.pendingJobs }} / {{ jobBatch.totalJobs }}
      </template>
      <template v-else>
        {{ $t("Process complete – The page will reload") }}
      </template>
      <div class="progress tw:mt-2 tw:bg-yellow-900/7 tw:h-3">
        <div class="progress-bar"
             :class="isProcessing ? 'bg-warning' : 'bg-success'"
             role="progressbar"
             :style="{ width: jobBatch.percentDone + '%' }"
             :aria-valuenow="jobBatch.percentDone"
             aria-valuemin="0"
             aria-valuemax="100">
        </div>
      </div>
    </Alert>
    <Alert v-if="error" variant="danger">
      {{ error }}
    </Alert>
  </div>
</template>
